// extracted by mini-css-extract-plugin
export var accept = "Cookie-module--accept--33162";
export var bounce = "Cookie-module--bounce--9db9c";
export var container = "Cookie-module--container--dcd53";
export var content = "Cookie-module--content--dc1ce";
export var decline = "Cookie-module--decline--a5e68";
export var dotMoveLeft = "Cookie-module--dot-move-left--88dbd";
export var dotMoveRight = "Cookie-module--dot-move-right--45651";
export var gradient = "Cookie-module--gradient--fd59e";
export var separatorWidth = "Cookie-module--separator-width--aff3d";